import { render, staticRenderFns } from "./SpecialRoomGroup.vue?vue&type=template&id=91de2724"
import script from "./SpecialRoomGroup.vue?vue&type=script&lang=js"
export * from "./SpecialRoomGroup.vue?vue&type=script&lang=js"
import style0 from "./SpecialRoomGroup.vue?vue&type=style&index=0&id=91de2724&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports